export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10465.38dda3f7.jpg";